export class ExcelHelper {
    /** Default helper for invoking an action and handling errors. */
    public static async tryCatch(callback, catchHint: string = "unknown") {
        try {
            await callback();
        } catch (error) {
            // Note: In a production add-in, you'd want to notify the user through your add-in's UI.
            console.error(`Error sync or load with excel api. ${catchHint}`, error);
        }
    }

    /**
         * Synchronizes, logs when error, the state between JavaScript proxy objects and the Office document, by executing instructions queued on the request context 
         * and retrieving properties of loaded Office objects for use in your code. 
         * This method returns a promise, which is resolved when the synchronization is complete.
    */
    public static async tryCatchContextSync(context: Excel.RequestContext, syncHint: string = "unknown") {
        await context.sync()
            .catch(function (error) {
                console.error(`Error Syncing ${syncHint}`, error);
                throw error;
            })
            .finally(function () {
                console.log(`Done Syncing ${syncHint}`);
            });
    }

  /**
    * Executes a batch script, if fails catches error in cosole then throws, that performs actions on the Excel object model, using a new RequestContext. When the promise is resolved, any tracked objects that were automatically allocated during execution will be released.
   * @param batch - A function that takes in a RequestContext and returns a promise (typically, just the result of "context.sync()").
   * The context parameter facilitates requests to the Excel application. Since the Office add-in and the Excel application run in
    * two different processes, the RequestContext is required to get access to the Excel object model from the add-in.
    */
  public static async tryCatchRunAsync(
    batch: (context: Excel.RequestContext) => Promise<void>,
    runHint: string = "unknown"
  ) {
    await Excel.run( async (context) => {
      await batch(context);
    })
      .catch(function (error) {
        console.error(`Error excel run batch ${runHint}`, error);
        if (error instanceof OfficeExtension.Error) {
          console.log(`Debug info: ${runHint}` + JSON.stringify(error.debugInfo));
        }
        throw error;
      })
      .finally(function () {
        console.log(`Done excel run batch ${runHint}`);
      });
  }
}
